import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import { withStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';

const StyledTab = withStyles({
  root: {
    minHeight: 'auto',
    padding: 5,
  },
  wrapper: {
    alignItems: 'flex-start',
  },
})(Tab);

function a11yProps(index: any) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

/**
 *
 * @param props take the profiles name and the value of the selected tab.
 * @constructor
 */
export default function VerticalTabsMenu(props) {
  const { t } = useTranslation();
  const {
    profiles = [],
    value,
    setValue,
    defaultName,
    disabled = false,
    hideDefault = false,
  } = props;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const classes = useStyles();
  return (
    <Tabs
      orientation="vertical"
      variant="scrollable"
      value={value}
      onChange={handleChange}
      aria-label="Vertical tabs"
      className={classes.tabs}
      scrollButtons="off"
    >
      {profiles.map((profile, index) => (
        <StyledTab
          disabled={disabled}
          label={`${
            profile?.default === true
              ? t('productGroups.defaultProductProfile')
              : profile?.state
                ? profile.state.description || profile?.state.name
                : profile?.country
                  ? profile?.country.description || profile?.country.name
                  : profile?.region
          } ${profile.is_test_market ? '(Test)' : ''}`}
          className={value === index ? classes.tabSelected : classes.tab}
          key={index}
          {...a11yProps(value)}
        />
      ))}
      {!hideDefault && (
        <StyledTab
          label={defaultName}
          className={
            value === profiles.length ? classes.tabSelected : classes.tab
          }
          {...a11yProps(profiles.length)}
        />
      )}
    </Tabs>
  );
}
